import {Injectable} from '@angular/core';
import {NbDialogService} from '@nebular/theme';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, tap} from 'rxjs/operators';
import {closeDialog, navigateTo, openDialog} from './app.actions';
import {Router} from '@angular/router';

@Injectable()
export class AppEffects {

  dialogRef: any;
  constructor(
    private actions$: Actions,
    private dialogService: NbDialogService,
    private router: Router
  ) {
  }

  openDialog$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(openDialog),
        map((x) =>
         this.dialogRef = this.dialogService.open(x.dialog.component, x.dialog.context)
        )
      );
    },
    {dispatch: false}
  );

  closeDialog$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(closeDialog),
        tap((x) =>
          this.dialogRef.close(x)
        )
      );
    },
    {dispatch: false}
  );

  navigateTo = createEffect(() => {
      return this.actions$.pipe(
        ofType(navigateTo),
        map(action => this.router.navigateByUrl(action.path))
      );
    },
    {dispatch: false}
  );
}
